/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const deviceReplaceV3 = {
  path: '/device-replace-v3',
  name: 'device-replace-v3',
  redirect: { name: 'device-replace-v3-record-list' },
  component: () => import(/* webpackChunkName: "expect" */ '@/views/device-replace-v3/index.vue'),
  children: [
    {
      path: 'record-list',
      name: 'device-replace-v3-record-list',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/record-list.vue'
        ),
    },
    {
      path: 'apply-form',
      name: 'device-replace-v3-apply-form',
      component: () =>
        import(/* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/apply-form.vue'),
    },
    {
      path: 'apply-warehouse-point',
      name: 'device-replace-v3-apply-warehouse-point',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/apply-warehouse-pinter.vue'
        ),
    },
    {
      path: 'apply-choose-device',
      name: 'device-replace-v3-apply-choose-device',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/apply-choose-device.vue'
        ),
    },
    {
      path: 'apply-choose-guide',
      name: 'device-replace-v3-apply-choose-guide',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/apply-choose-guide.vue'
        ),
    },
    {
      path: 'pay-front-money',
      name: 'device-replace-v3-pay-front-money',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/pay-front-money.vue'
        ),
    },
    {
      path: 'record-detail',
      name: 'device-replace-v3-record-detail',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/record-detail.vue'
        ),
    },
    {
      path: 'pay-rest-money',
      name: 'device-replace-v3-pay-rest-money',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/pay-rest-money.vue'
        ),
    },
    {
      path: 'network-detail',
      name: 'device-replace-v3-network-detail',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/network-detail.vue'
        ),
    },
    {
      path: 'activity-notification',
      name: 'device-replace-v3-activity-notification',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/activity-notification.vue'
        ),
    },
    {
      path: 'self-check-device-list',
      name: 'device-replace-v3-self-check-device-list',
      component: () =>
        import(
          /* webpackChunkName: "device-replace" */ '@/views/device-replace-v3/self-check-device-list.vue'
        ),
    },
  ],
}
export default deviceReplaceV3
